import { SchemaValidation } from 'utilities/validationCheck'

export const resetPasswordOTPSchema = SchemaValidation.object().shape({
  otp: SchemaValidation.string().required('Kode OTP tidak boleh kosong'),
})
